import { render } from "./Veranstaltungen.vue?vue&type=template&id=75c40b38&scoped=true"
import script from "./Veranstaltungen.vue?vue&type=script&lang=js"
export * from "./Veranstaltungen.vue?vue&type=script&lang=js"

import "./Veranstaltungen.vue?vue&type=style&index=0&id=75c40b38&scoped=true&lang=css"

import exportComponent from "C:\\Git-Local\\afm.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c40b38"]])

export default __exports__